import { z } from "zod";
import { DmaCalculationState } from "../dma-calculation-state";
import { dmaCalculationResultsDtoSchema } from "./dma-calculation-results.schema";
export const dmaRunningCalculationStatusDtoSchema = z.object({
    state: z.literal(DmaCalculationState.Running),
    jobStartedAt: z.string().datetime({ offset: true }),
    currentStep: z.number().int(),
    totalSteps: z.number().int(),
    stepProgress: z.number(),
    stepStartedAt: z.string().datetime({ offset: true }),
    stepTimeout: z.number(),
    statusMessage: z.string(),
    partialResults: dmaCalculationResultsDtoSchema,
});
